<template>
  <div class="setBox">
    <div class="them">信息更新</div>
    <div class="btn" @click="applyUpdate()">申请更新</div>
    <el-table :data="updateList" class="tableControll" empty-text="暂无数据">
      <el-table-column
        style="margin-left: 30px"
        type="index"
        label="序号"
        width="80px"
        align="center"
      >
      </el-table-column>
      <el-table-column label="更新类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1" class="normal">企业基本信息</span>
          <span v-if="scope.row.type === 2" class="normal"
            >专职专业人员信息</span
          >
        </template>
      </el-table-column>
      <el-table-column align="center" label="变更状态 ">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" class="blue status">待审核</span>
          <span v-else-if="scope.row.status == 1" class="green status"
            >审核通过</span
          >
          <span v-else class="red status">审核驳回</span>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" align="center" label="申请时间">
      </el-table-column>
      <el-table-column prop="address" align="center" label="操作">
        <template slot-scope="scope">
          <!--变更审核中，变更通过-->
          <div
            v-if="scope.row.status == 0 || scope.row.status == 1"
            class="handle"
          >
            <el-link
              @click="goDetail(scope.row.id, scope.row.type)"
              class="handle"
              >查看详情
            </el-link>
          </div>
          <!--变更驳回 操作按钮-->
          <div v-else class="handle">
            <div class="total">
              <el-link
                @click="goDetail(scope.row.id, scope.row.type)"
                class="handle"
                >查看详情
              </el-link>
              <el-link
                class="handle"
                @click="
                  goEdit(
                    scope.row.id,
                    scope.row.type,
                    scope.row.status,
                    scope.row.note_id
                  )
                "
                >编辑
              </el-link>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="更新类型"
      :visible.sync="DialogVisible"
      width="540px"
      :close-on-click-modal="false"
    >
      <div class="tip">
        <img src="@/assets/img/warn.png" alt="" />
        <span>每次变更只可以选择一个变更类型</span>
      </div>
      <div class="cont">
        <el-radio-group v-model="radio">
          <el-radio
            :label="1"
            :disabled="isDisable1"
            :class="{ active: radio == 1 }"
            style="padding-top: 26px"
            >企业基本信息
          </el-radio>
          <el-radio
            :disabled="isDisable2"
            :label="2"
            :class="{ active: radio == 2 }"
            >专职专业人员信息 <br />
            &nbsp;&nbsp;&nbsp;&nbsp;（其他专职人员）
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBtn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { updateHistory, getUpdateRecordID } from "@/api/update.js";

export default {
  name: "updateIndex",
  data() {
    return {
      DialogVisible: false, //弹窗
      radio: null,
      updateList: [], //变更列表
      record_id: null,
      isDisable1: false, // 弹窗里的企业信息 不禁点
      isDisable2: false, // 弹窗里的人员信息 不禁点
      status1: null, // 企业信息最新一条的状态
      status2: null, // 人员最新一条的状态
    };
  },
  created() {
    this.init();
    this.getRecordId();
  },
  methods: {
    //驳回后点击编辑
    goEdit(id, type, status, note_id) {
      if (type == 1) {
        // 企业信息驳回后编辑
        this.$router.push({
          name: "updateCompany",
          query: { id: id, status: status, type: type, note_id: note_id },
        });
      } else {
        // 人员信息驳回后编辑
        this.$router.push({
          name: "zzEdit",
          query: { id: id, status: status, note_id: note_id },
        });
      }
    },
    //点击申请更新按钮
    applyUpdate() {
      // console.log(typeof rew);

      this.DialogVisible = true;

      // console.log(this.updateList);

      let arrNew = this.updateList.slice();
      let re = arrNew.reverse();
      //反转后的数组

      // console.log(typeof re);
      // console.log(this.updateList, "this.updateList");
      re.forEach((item) => {
        //企业变更存在待审核情况，弹窗中 企业变更禁点
        if (item.status == 0 && item.type == 1) {
          this.isDisable1 = true;
        }
        if (item.status == 0 && item.type == 2) {
          this.isDisable2 = true;
        }
        //拿到 企业信息最新一条的状态
        if (item.type == 1) {
          this.status1 = item.status;
        }
        //拿到 人员最新一条的状态
        if (item.type == 2) {
          this.status2 = item.status;
        }
      });
    },
    async init() {
      const res = await updateHistory();
      this.updateList = res;
      // console.log(this.updateList, "后端给的数据");
    },
    async getRecordId() {
      const res = await getUpdateRecordID();
      this.record_id = res.record_id;
    },
    goDetail(val, type) {
      if (type == 1) {
        //查看企业进本信息详情
        this.$router.push({ name: "updateResult", query: { id: val } });
      } else {
        //查看人员 信息详情
        this.$router.push({
          name: "updateZzResult",
          query: { id: val },
        });
      }
    },
    //确定变更按钮
    confirmBtn() {
      //企业 变更成功 以后拿最新的一条
      if (this.radio == 1) {
        //变更企业
        this.$router.push({
          name: "updateCompany",
          query: { type: 1, record_id: this.record_id },
        });
      } else if (this.radio == 2) {
        this.$router.push({
          name: "updateZz",
          query: { type: 2, record_id: this.record_id },
        });
      } else {
        //人员和企业都在待审核的时候，都是禁点按钮，那么关闭弹窗
        this.DialogVisible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.setBox {
  background: #ffffff;
  border-radius: 2px;
  padding: 16px 20px 60px;

  .them {
    font-size: 20px;
    color: #333;
  }

  .btn {
    width: 100px;
    height: 32px;
    background: #4379f6;
    margin-top: 24px;
    font-size: 12px;
    display: flex;
    align-items: center;
    color: #ffffff;
    justify-content: center;
    cursor: pointer;
  }

  .tableControll {
    width: 100%;
    border: solid 1px rgb(235, 238, 245);
    border-bottom: unset;
    margin-top: 20px;
  }

  .total {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .normal {
    font-size: 12px;
    color: #333333;
  }

  .handle {
    font-size: 12px;
    color: #666666;
    margin-left: 20px;
    text-decoration: unset;

    &:first-child {
      margin-left: unset;
    }

    &:hover {
      color: #4379f6;
    }
  }

  .link {
    color: #666666;
    text-decoration: unset;

    &:hover {
      color: #4379f6 !important;
    }
  }

  .red {
    background: #f8eaea;
    color: #f32323;
  }

  .green {
    background: #e8f8e9;
    color: #25a22d;
  }

  .blue {
    background: #d2e7fb;
    color: #4496f1;
  }

  .status {
    font-size: 12px;
    padding: 2px;
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #666;
    font-weight: normal;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table__empty-text {
    line-height: unset;
  }

  /deep/ .el-dialog__body {
    padding: unset;
  }

  /deep/ .el-dialog__header {
    border-bottom: 1px solid #dddddd;
  }

  /deep/ .el-dialog__footer {
    background: #f5f5f5;
    height: 70px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 30px;
  }

  /deep/ .el-button--primary {
    width: 100px;
    background: #f39020;
  }

  /deep/ .el-button {
    padding: unset;
    width: 100px;
    height: 32px;
    border-radius: unset;
  }

  /deep/ .el-button--primary {
    border-color: unset;
  }

  .tip {
    display: flex;
    align-items: center;
    width: 100%;
    height: 32px;
    background: #f9f4e8;
    padding: 0 12px;
    box-sizing: border-box;

    img {
      width: 13px;
      height: 13px;
    }

    span {
      margin-left: 7px;
      font-size: 14px;
      color: #262b36;
    }
  }

  .cont {
    padding: 30px;

    .active {
      border: 1px solid #4379f6 !important;
    }

    /deep/ .el-radio-group {
      display: flex;
      align-items: center;
    }

    /deep/ .el-radio {
      flex: 1;
      height: 90px;
      border: 1px solid #ddd;
      padding: 15px 40px 0px;
      box-sizing: border-box;
    }

    /deep/ .el-radio__label {
      line-height: 30px;
    }
  }
}
</style>
